function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M186.328 3.44527L162.863 147.653H200.405L223.873 3.44527H186.328ZM131.276 3.44527L95.482 102.63L91.248 81.2723L91.251 81.2793L90.318 76.4923C85.986 67.1563 75.953 49.4123 57.008 34.2693C51.407 29.7933 45.761 25.9733 40.303 22.7103L72.834 147.653H111.95L171.683 3.44527H131.276ZM277.797 43.4803C277.797 27.1763 314.36 29.2713 330.426 38.1243L335.783 7.15225C335.783 7.15225 319.249 0.864258 302.015 0.864258C283.383 0.864258 239.14 9.01226 239.14 48.6033C239.14 85.8633 291.068 86.3263 291.068 105.888C291.068 125.45 244.494 121.954 229.124 109.614L223.538 141.987C223.538 141.987 240.301 150.135 265.92 150.135C291.536 150.135 330.192 136.864 330.192 100.765C330.192 63.2723 277.797 59.7803 277.797 43.4803ZM430.997 3.44527H400.812C386.874 3.44527 383.48 14.1923 383.48 14.1923L327.492 147.653H366.623L374.451 126.234H422.179L426.582 147.653H461.054L430.997 3.44527ZM385.27 96.6413L404.998 42.6753L416.096 96.6413H385.27Z",
  fill: "#005BAC"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M79.132 17.0223C79.132 17.0223 77.578 4.00726 60.988 4.00726H0.715033L0.0090332 6.45326C0.0090332 6.45326 28.981 12.3593 56.776 34.4863C83.338 55.6343 92.003 81.9963 92.003 81.9963L79.132 17.0223Z",
  fill: "#F6AC1D"
});

var SvgVisa = function SvgVisa(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 462 151",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVisa, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/visa.9af04457.svg";
export { ForwardRef as ReactComponent };